import React from 'react'
import aboutImg from '../assets/aboutImg.jpeg'
import about2 from '../assets/about-section2.jpg'

const contactCards = [
  { icon: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6', title: 'Send Us Mail', text: 'sewabharti1980@gmail.com' },
  { icon: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 012 2.21 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z', title: 'Call Us Anytime', text: '0184-2255874' },
  { icon: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z M12 10m-3 0a3 3 0 106 0 3 3 0 00-6 0', title: 'Visit Our Office', text: 'Sewa Bharti Haryana Pradesh\nSewa Shree Aashram, Valmiki Basti,\nArjun Gate, Karnal-132001 (Haryana)' },
]

export default function About() {
  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-2">
          <h1>About Us</h1>
          <p className="breadcrumb">Home › About Us</p>
        </div>
      </div>

      {/* Contact cards */}
      <section className="py-16" style={{background:'white'}}>
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          {contactCards.map((c, i) => (
            <div key={i} className="flex flex-col items-center text-center rounded-2xl p-8 transition-all hover:-translate-y-1"
              style={{background:'white',border:'1px solid rgba(0,0,0,0.07)',boxShadow:'0 4px 20px rgba(13,27,62,0.06)'}}>
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 -mt-14 shadow-lg"
                style={{background:'linear-gradient(135deg,var(--saffron),var(--saffron-dark))'}}>
                <svg className="w-6 h-6 text-white" fill="none" stroke="white" strokeWidth="1.8" viewBox="0 0 24 24"><path d={c.icon}/></svg>
              </div>
              <h3 className="font-semibold text-base mb-2" style={{color:'var(--navy)'}}>{c.title}</h3>
              <p className="text-sm leading-relaxed whitespace-pre-line" style={{color:'var(--muted)'}}>{c.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* About story */}
      <section className="py-16" style={{background:'var(--cream)'}}>
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="section-tag">Our Story</div>
            <h2 className="mb-6" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>Who We Are</h2>
            <div className="space-y-4" style={{color:'var(--muted)',lineHeight:1.85,fontSize:'15.5px'}}>
              <p><strong style={{color:'var(--text)'}}>Sewa Bharti Haryana</strong> is a non-profit, non-governmental organization that works for the welfare of the people of Haryana, India. It was founded in 1980 and is headquartered in Karnal, Haryana.</p>
              <p>Sewa Bharti Haryana has over a thousand volunteers working in all districts of the state. The organization works in a variety of areas, focused on child education, health, skill education, and social welfare.</p>
              <p>It runs many social service centers including schools, hospitals, vocational training centers, and hostels. Sewa Bharti Haryana also provides relief and rehabilitation services during natural disasters and has done prominent work during the pandemic.</p>
              <p>Sewa Bharti Haryana's mission is to serve the poor and needy without any discrimination based on caste, creed, religion, or region.</p>
            </div>
          </div>
          <div className="relative">
            <img src={aboutImg} alt="About Sewa Bharti" className="w-full rounded-2xl object-cover" style={{height:'460px',boxShadow:'0 24px 60px rgba(13,27,62,0.12)'}}/>
            <div className="absolute bottom-8 left-8 text-white rounded-2xl px-6 py-5" style={{background:'var(--navy)',boxShadow:'0 12px 30px rgba(13,27,62,0.3)'}}>
              <div className="font-bold" style={{fontFamily:'Playfair Display,serif',fontSize:'36px',color:'var(--saffron-light)'}}>1980</div>
              <div className="text-sm" style={{color:'rgba(255,255,255,0.6)'}}>Year Founded</div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center'}}>What We Stand For</div>
            <h2 style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>Our Core Values</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon:'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z', title:'Compassion', desc:'Serving every individual with genuine care and empathy regardless of their background.' },
              { icon:'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 7a4 4 0 100 8 4 4 0 000-8z M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75', title:'Inclusivity', desc:'No discrimination of caste, creed, religion, or region in our service to humanity.' },
              { icon:'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z', title:'Integrity', desc:'Maintaining the highest standards of transparency and accountability in all our actions.' },
              { icon:'M12 2L2 7l10 5 10-5-10-5z M2 17l10 5 10-5 M2 12l10 5 10-5', title:'Empowerment', desc:'Equipping individuals and communities with tools to build their own sustainable futures.' },
            ].map((v, i) => (
              <div key={i} className="rounded-2xl p-7 text-center transition-all hover:-translate-y-1" style={{background:'var(--cream)',border:'1px solid rgba(0,0,0,0.06)'}}>
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-5" style={{background:'var(--saffron-pale)'}}>
                  <svg className="w-6 h-6" fill="none" stroke="var(--saffron)" strokeWidth="1.8" viewBox="0 0 24 24"><path d={v.icon}/></svg>
                </div>
                <h3 className="font-semibold text-base mb-2" style={{color:'var(--navy)'}}>{v.title}</h3>
                <p className="text-sm leading-relaxed" style={{color:'var(--muted)'}}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
